import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useIdParams } from '@feathr/extender/hooks';

import Page from '../../Page';
import DonationFormBuilder from './DonationFormBuilder';
import DonationFormEmbedButton from './DonationFormBuilder/DonationFormEmbedButton';
import DonationFormEmbedModal from './DonationFormBuilder/DonationFormEmbedModal';
import { DonationFormBuilderProvider } from './DonationFormBuilder/useDonationFormBuilder';

import * as styles from './DonationFormEditPage.css';

function DonationFormEditPage(): JSX.Element {
  const donationForm = useIdParams('donationForm');

  return (
    <DonationFormBuilderProvider donationForm={donationForm}>
      <Page
        actions={<DonationFormEmbedButton />}
        collapseHeader={true}
        contentClassName={styles.root}
        includeCurrentPageCrumb={true}
        legacyScrollClassName={styles.legacyScroll}
        loading={donationForm.isPending}
        title={donationForm.name}
      >
        <DonationFormEmbedModal />
        <DonationFormBuilder.Content />
        <DonationFormBuilder.ActionBar />
      </Page>
    </DonationFormBuilderProvider>
  );
}

export default observer(DonationFormEditPage);
